/**
 * Trigger a browser download for a fetched Blob. Creates a temporary object URL,
 * clicks a synthetic anchor, then revokes the URL. Used by the orders export
 * menu (ported from cpanel's `downloadFile` util).
 */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
